import { createApp, h } from 'vue';

import App from '@/App.vue';

import { createPinia } from 'pinia';
const store = createPinia();

import { createVueApp, getSearchParams } from '@sfcli/app-shared';

let BlankScreenDetectorReact: any = null;

import loadStaticModules from './loadStaticModules';
import loadRuntimeModules from './loadRuntimeModules';

import { setAppConfig } from './appConfig';
import type { IAppConfig, IBuildConfig } from '../types';

const buildConfig: IBuildConfig = {
  mpa: false,
  keepAlive: true,
  router: false,
  icestarkType: 'es',
  hasEnabledBlankScreenDetector: false,
};
const runtimeValue: any = {};

// TODO: createBaseApp() 返回一个 createBaseApp，命名需要优化下
const frameworkAppBase = createVueApp({
  loadRuntimeModules,
  createElement: createApp,
  runtimeAPI: {
    getSearchParams,
  },
  runtimeValue,
});

const runAppInit = (appConfig: IAppConfig = {}) => {
  // store appConfig in case of server side render
  // server bundle will to get appConfig after run runApp
  setAppConfig(appConfig as IAppConfig);
  // load static modules before init runtime such as request
  loadStaticModules(appConfig as IAppConfig);
  // 页面中渲染APP
  const context: any = {};
  const { runtime, appConfig: modifiedAppConfig } = frameworkAppBase<any>(
    appConfig,
    buildConfig,
    context
  );

  const entry = App;

  let wrapedApp: ReturnType<typeof h>;
  if (
    buildConfig.hasEnabledBlankScreenDetector &&
    modifiedAppConfig?.app?.errorBoundary
  ) {
    const slots: Record<string, () => ReturnType<typeof h>> = {
      default: () => h(entry), // 默认插槽
    };
    if (modifiedAppConfig.app.ErrorBoundaryFallback) {
      slots.fallback = () => h(modifiedAppConfig.app.ErrorBoundaryFallback);
    }
    wrapedApp = h(
      BlankScreenDetectorReact,
      {
        onError: modifiedAppConfig.app.onErrorBoundaryHandler,
      },
      slots
    );
  }
  const app = createApp({
    render() {
      return wrapedApp || h(entry);
    },
  });

  app.use(store);

  modifiedAppConfig?.app?.beforeMount?.(app);

  const rootId = modifiedAppConfig?.app?.rootId || '#app';
  return { app, rootId };
};

// 准备好数据调用App
export function runApp(appConfig: IAppConfig = {}) {
  const { app, rootId } = runAppInit(appConfig);
  app.mount(rootId);

  return { app };
}

export default {
  createBaseApp: frameworkAppBase,
};
